import {
  sendAddToBoard,
  sendErasesFromBoard,
  sendMyTease,
  sendOthersCanEdit,
  sendClearBoard,
  sendLiveBoard,
  sendPinnedShare,
} from "slices/channels/spaceChannelSlice";
import { thisIsMe, turnOffShare } from "slices/spaceSlice";
import Resizer from "react-image-file-resizer";
import { throttle } from "lodash";
import { selectMePinnedShare, selectMyLuid } from "slices/spaceMediaSlice";
import {
  exportToBlob,
  fileSave,
  serializeAsJSON,
} from "@ralphefficespace/board";

// let dispatch = null;
let getState = null;
import("Store").then((module) => {
  // dispatch = module.store.dispatch;
  getState = module.store.getState;
});

const SYNC_TEASE_INTERVAL_MS = 10000;
const TEASE_HEIGHT = 324;
const TEASE_WIDTH = 588;
export const BOARD_LIBRARY = "boardLibrary";

const INITIAL_BOARD_STATE = {
  owner_luid: 0,
  others_can_edit: false,
  elements: [],
  api: null,
};

let boards = {};

const myBoard = () => {
  if (selectMyLuid(getState())) return boards[selectMyLuid(getState())];
  else return null;
};

window.getMyBoard = myBoard;
window.getBoards = () => boards;

const queueBroadcastTease = throttle(
  async () => {
    try {
      let blob64 = await makeMyTease();
      sendMyTease(blob64);
      queueBroadcastTease();
    } catch (e) {
      window.log("Could not broadcast tease: " + JSON.stringify(e, null, 4));
    }
  },
  SYNC_TEASE_INTERVAL_MS,
  { leading: false }
);

export async function makeMyTease() {
  let board = myBoard();
  if (!board || !board.api) throw Error("Could not find board");
  const blob = await exportToBlob({
    elements: board.api.getSceneElements(),
    mimeType: "image/jpeg",
  });
  const resizedBlob = await resizeTease(blob);
  const blob64 = await blobToBase64(resizedBlob);
  receivedBoardTease(selectMyLuid(getState()), blob64);
  return blob64;
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export const setBoardAPI = (luid, api) => {
  console.log("Set BOARD api");
  console.log(JSON.stringify(luid, null, 4));
  console.log(JSON.stringify(api, null, 4));
  // console.log(JSON.stringify(boards, null, 4));

  if (boards[luid]) boards[luid].api = api;
};

export const onChangeBoard = (luid, currentElements, _appState, _files) => {
  // console.log("ONCHANGE BOARD");
  // console.log(boards);
  // console.log(appState);
  let board = boards[luid];
  if (!board || !board.api) return;

  let adds = false;
  let erases = [];
  console.log("CurrentElements:");
  console.log(JSON.stringify(currentElements, null, 4));
  currentElements.forEach((element, i) => {
    // the socket messaging may be called many times if someone selected many items and either deleted them or copy and pastes them

    if (element.isDeleted) erases.push(i);
    else if (
      !board.elements[i] ||
      element.version !== board.elements[i].version
    ) {
      adds = true;
      board.elements[i] = { ...element };
      sendAddToBoard(board.owner_luid, board.elements[i]);
    }
  });
  // let visible = board.api.getSceneElements();
  // board.elements = visible;
  // console.log(erases);
  if (erases[0] !== undefined) {
    // debugger;
    if (erases.length === currentElements.length) {
      sendClearBoard(board.owner_luid);
      board.elements = [];
    } else if (erases[0]) {
      for (let i = erases.length - 1; i >= 0; i--) {
        sendErasesFromBoard(board.owner_luid, currentElements[erases[i]].id);
        board.elements.splice(erases[i], 1);
      }
    }
    // So we don't send the same deleted element multiple times:
    board.api.updateScene({ elements: board.api.getSceneElements() });
  }

  if (adds || erases[0]) queueBroadcastTease();
};

export async function initialiseBoard(luid) {
  boards[luid] = JSON.parse(JSON.stringify(INITIAL_BOARD_STATE));
  let board = boards[luid];
  board.owner_luid = luid;

  try {
    let { oce, elements } = await sendLiveBoard(luid);

    board.others_can_edit = oce;
    board.elements = JSON.parse(JSON.stringify(elements)); //  so change obj references
    if (selectMePinnedShare(getState())) sendPinnedShare(true);

    return {
      scene: {
        elements,
        appState: {
          viewModeEnabled: !thisIsMe(luid) && !board.others_can_edit,
          isCollaborating: board.others_can_edit,
          exportBackground: false,
        },
      },
    };
  } catch (e) {
    window.log("Error getting initial data: " + JSON.stringify(e, null, 4));
    deleteBoard(luid);
    if (thisIsMe(luid)) turnOffShare();
  }
}

export function deleteBoard(luid) {
  delete boards[luid];
}

export function toggleOthersCanEdit(luid) {
  let board = boards[luid];
  if (!board || !board.api || !thisIsMe(luid)) return;
  sendOthersCanEdit(!board.api.getAppState().isCollaborating);
}

export const receivedBoardElements = (luid, { oce, elements }) => {
  let board = boards[luid];
  if (!board || !board.api) return;
  board.others_can_edit = oce;
  board.elements = JSON.parse(JSON.stringify(elements)); //  so change obj references

  board.api.updateScene({
    elements,
    appState: {
      viewModeEnabled: !thisIsMe(luid) && !board.others_can_edit,
      isCollaborating: board.others_can_edit,
    },
  });
};

export const receivedBoardTease = (luid, tease) => {
  let elem = document.getElementById(`${luid}-board-image`);
  // console.log(tease);
  fetch(tease)
    .then((res) => res.blob())
    .then((blob) => {
      if (elem) {
        // console.log("Elem found");
        elem.style.background = "url('" + URL.createObjectURL(blob) + "')";
        elem.querySelector(".board-name").style.display = "none";
      }
    });
};

export const receivedBoardAdd = (luid, newElem) => {
  let board = boards[luid];
  if (!board || !board.api) return;

  let position = board.elements.findIndex((elem) => elem.id === newElem.id);

  if (position > -1) board.elements[position] = newElem;
  else board.elements.push(newElem);

  board.api?.updateScene({ elements: board.elements });
};

export const receivedBoardErase = (luid, erasedID) => {
  let board = boards[luid];
  if (!board || !board.api) return;

  let position = board.elements.findIndex((elem) => elem.id === erasedID);

  if (position > -1) board.elements.splice(position, 1);

  board.api?.updateScene({ elements: board.elements });
};

export const receivedBoardClear = (luid) => {
  let board = boards[luid];
  if (!board || !board.api) return;

  board.elements = [];
  board.api.updateScene({ elements: [] });
  // may need to do more updates to appState such as current Element selected , etc
};

export const receivedBoardOCE = (luid, value) => {
  let board = boards[luid];
  if (!board || !board.api) return;

  board.others_can_edit = value;
  board.api.updateScene({
    appState: {
      viewModeEnabled: !thisIsMe(luid) && !board.others_can_edit,
      isCollaborating: board.others_can_edit,
    },
  });
};

export const receivedBoardOCERequest = () => {
  // TODO
  window.log("Received Board OCE Request");
};

export async function onLibraryChange(items) {
  if (!items.length) {
    localStorage.removeItem(BOARD_LIBRARY);
    return;
  }
  const serializedItems = JSON.stringify(items);
  localStorage.setItem(BOARD_LIBRARY, serializedItems);
}

export const loadImages = (data) => {
  if (!data.scene) {
    return;
  }
  // if (data.scene.elements) {
  //   collabAPI
  //     .fetchImageFiles({
  //       elements: data.scene.elements,
  //     })
  //     .then(({ loadedFiles, erroredFiles }) => {
  //       excalidrawAPI.addFiles(loadedFiles);
  //       updateStaleImageStatuses({
  //         excalidrawAPI,
  //         erroredFiles,
  //         elements: excalidrawAPI.getSceneElementsIncludingDeleted(),
  //       });
  //     });
  // }
  // try {
  //   data.scene.libraryItems =
  //     JSON.parse(localStorage.getItem(BOARD_LIBRARY)) || [];
  // } catch (error) {
  //   window.log(
  //     "Error Getting Library Items" + JSON.stringify(error, null, 4)
  //   );
  // }
};

export async function fetchImageFiles(elements) {
  // Fetch Files and return { loadedFiles, erroredFiles } (do not throw error)
}

export async function getBoardPreview(luid) {
  let board = boards[luid];
  if (!board || !board.api) return;

  const blob = await exportToBlob({
    elements: board.api.getSceneElements(),
    mimeType: "image/png",
    maxWidthOrHeight: 400,
  });
  return URL.createObjectURL(blob);
}

export async function downloadBoardImage(luid) {
  let board = boards[luid];
  if (!board || !board.api) return;
  window.log("DOWNLOADING BOARD IMAGE");

  const blob = await exportToBlob({
    elements: board.api.getSceneElements(),
    mimeType: "image/png",
    maxWidthOrHeight: 1200,
  });
  await fileSave(blob, {
    name: board.api.getAppState().name,
    extension: "png",
    description: "Effice Whiteboard Image",
  });
}

export async function downloadBoardFile(luid) {
  let board = boards[luid];
  if (!board || !board.api) return;
  window.log("DOWNLOADING BOARD FILE");

  const serialized = serializeAsJSON(
    board.api.getSceneElements(),
    board.api.getAppState(),
    null,
    "local"
  );
  const blob = new Blob([serialized], {
    type: "application/vnd.efficeboard+json",
  });

  const fileHandle = await fileSave(blob, {
    name: board.api.getAppState().name,
    extension: "efficeboard",
    description: "Effice Whiteboard File",
  });
  board.api.updateScene({ appState: { fileHandle } });
  // return jsonFile;
}

export function resolvablePromise() {
  let resolve;
  let reject;
  const promise = new Promise((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });
  promise.resolve = resolve;
  promise.reject = reject;
  return promise;
}

const resizeTease = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      TEASE_WIDTH,
      TEASE_HEIGHT,
      "JPEG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "blob",
      0,
      0
    );
  });
